import {
  SIGN_UP_BEGIN,
  SIGN_UP_SUCCESS,
  VERIFY_EMAIL_BEGIN,
  SET_LOGIN_USER_STATUS,
  START_LOGIN,
  CLEAR_AUTH_DATA,
  SET_USER_PROFILE_DATA,
  UPDATE_PASSWORD_STARTED,
  UPDATE_PROFILE_STARTED,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_ORGANIZATION_STARTED,
  UPDATE_ORGANIZATION_SUCCESS,
  FORGET_PASSWORD_STARTED,
  FORGET_PASSWORD_SUCCESS,
  RESET_PASSWORD_STARTED,
  RESET_PASSWORD_SUCCESS,
  VERIFY_EMAIL_SUCCESS,
  LOGIN_EMAIL_VERIFY,
} from "../actionTypeConstants/constants";

const initialState = {
  isAuthenticated: false,
  isLoginStarted: false,
  isUpdatePasswordStarted: false,
  isUpdateProfileStarted: false,
  isUpdateOrganizationStarted: false,
  isForgetPasswordStarted: false,
  isResetPasswordStarted: false,
  verifyEmailRes: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_UP_BEGIN:
      return { state };
    case SIGN_UP_SUCCESS:
      const data = action.payload;
      return { ...state, verifyEmailRes: data };
    case VERIFY_EMAIL_BEGIN:
      return { state };
    case VERIFY_EMAIL_SUCCESS:
      return { ...state, emailVerified: true, verifyEmailRes: {} };
    case SET_LOGIN_USER_STATUS:
      const { success } = action.payload;
      return { ...state, isAuthenticated: success };
    case LOGIN_EMAIL_VERIFY: {
      const data = action.payload;
      return { ...state, verifyEmailRes: data };
    }
    case START_LOGIN:
      const { isStarted } = action.payload;
      return { ...state, isLoginStarted: isStarted };
    case UPDATE_PASSWORD_STARTED:
      return { ...state, isUpdatePasswordStarted: action.payload.isStarted };
    case SET_USER_PROFILE_DATA:
      const { profileData } = action.payload;
      delete profileData.api_token;
      delete profileData.id;
      return { ...state, profileData };
    case CLEAR_AUTH_DATA:
      return { ...initialState };
    case UPDATE_PROFILE_STARTED:
      return { ...state, isUpdateProfileStarted: action.payload.isStarted };
    case UPDATE_PROFILE_SUCCESS: {
      let {profileData} = state;
      const {name, phone} = action.payload.data
      profileData = {
        ...profileData,
        name,
        phone
      }
      return { ...state, profileData };
    }
    case UPDATE_ORGANIZATION_STARTED:
      return { ...state, isUpdateOrganizationStarted: action.payload.isStarted };
    case UPDATE_ORGANIZATION_SUCCESS: {
      let {profileData} = state;
      const {org_name, size, website, country_code, country_name} = action.payload.data
      let {organization} = profileData;
      organization = {
        ...organization,
        country_code: country_code,
        country_name: country_name,
        name: org_name,
        size: size,
        website: website,
      }
      profileData = {
        ...profileData,
        organization: organization
      }
      
      return { ...state, profileData };
    }
    case FORGET_PASSWORD_STARTED:
      return { ...state, isForgetPasswordStarted: action.payload.isStarted };
    case FORGET_PASSWORD_SUCCESS: {
      return {...state, forgetPasswordRes: action.payload.data};
    }
    case RESET_PASSWORD_STARTED:
      return { ...state, isResetPasswordStarted: action.payload.isStarted };
    case RESET_PASSWORD_SUCCESS: {
      return {...state, passwordChanged: true  };
    }
    default:
      return state;
  }
};
